import {Stack, Box, Typography, List, ListItem, ListItemIcon, Button} from '@mui/material';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import Timer from '../Timer';
import opp from '../../utils/opp'
import '../styles/Game.css'
import '../styles/Home.css'
import OutlinedFlagRoundedIcon from '@mui/icons-material/OutlinedFlagRounded';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ShareIcon from '@mui/icons-material/Share';
import LogoutIcon from '@mui/icons-material/Logout';

// LeftSideBar contains information about the room:
// roomID, modes, hints remaining, etc.
export default function GameSideBar({opTime, myTime, setMyTime, setOpTime, turn, gameState, color, setDrawConfirmation, setResignConfirmation, onExport, onExit}) {

    return (
      <Box
        sx={{
          width: 380,
          flexShrink: 0,
          borderRadius: 7,
          backgroundColor: '#36454F',
          display: {
            xs: 'none',
            md: 'block',
          },
          top: { md: 96 },
          position: { md: 'sticky' },
        }}
      >

          <Typography sx={{ mt: 7, mb: 2, ml:4 }} variant="h4" align='left' component="div">
            Game Detail
          </Typography>

            <List dense={false} sx={{alignItems:'center'}}>

                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    <HourglassEmptyOutlinedIcon sx={{fontSize: '42px', color: '#8B8000', backgroundColor: opp(color), borderRadius: 2}}/>
                  </ListItemIcon>
                  <Timer minSecs={opTime} setTime={setOpTime} isRunning={!turn && gameState === 'start'}/>
                 
                </ListItem>

                <ListItem sx={{width: 'auto', mx: 2}}>
                <ListItemIcon sx={{ mr: 2}}>
                    <HourglassEmptyOutlinedIcon sx={{fontSize: '42px', color: '#8B8000', backgroundColor: color, borderRadius: 2}}/>
                </ListItemIcon>
                  <Timer minSecs={myTime} setTime={setMyTime} isRunning={turn && gameState === 'start'}/>
                </ListItem>

            </List>

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="18vh"
            >
            <Stack direction='row' spacing='1.5em'>
              <Button className='btn2' onClick={() => setResignConfirmation(true)} endIcon={<OutlinedFlagRoundedIcon/>}> Resign </Button>
              <Button className='btn2' onClick={() => setDrawConfirmation(true)} endIcon={<HandshakeOutlinedIcon/>}> Draw </Button> 
            </Stack>
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="20vh"
            >
            <Stack direction='column' spacing='2em'> 
              {gameState === 'afterGame' ? <Button className='btn3' onClick={onExport} endIcon={<ShareIcon/>}> Export Your Game </Button>  : <></>}
              {gameState === 'afterGame' ? <Button className='btn3' onClick={onExit} endIcon={<LogoutIcon/>}> Play another game </Button>  : <></>}
            </Stack>

            </Box>
    </Box>
    )
}
